import { type VolumeBasedPriceV1 } from '@redteclab/api/clients/bully'

import {
  FEATURE_TOGGLE_VOLUME_BASED_PRICES,
  useFeatureToggle,
} from '../../../feature-toggles'

export const useShouldRenderVolumePricing = (
  volumeBasedPrices?: VolumeBasedPriceV1[],
): boolean => {
  const isVolumePricingFeatureEnabled = useFeatureToggle(
    FEATURE_TOGGLE_VOLUME_BASED_PRICES,
  )

  const hasVolumePricing = Boolean(
    volumeBasedPrices && volumeBasedPrices.length > 1,
  )

  return isVolumePricingFeatureEnabled && hasVolumePricing
}
